import { buildCompanyProfilePayload } from "./companyDetailsFormUtils";
import {
  createCompanyProfileApi,
  fetchCompanyProfiles,
  updateCompanyProfileApi,
} from "../billing/companyDetailsApi";

/** @deprecated Company profiles are stored in the database. Use fetchCompanyProfiles from companyDetailsApi. */
export const COMPANY_STORAGE_KEY = "companyDetailsProfiles";
const LEGACY_STORAGE_KEY = "companyDetailsProfile";

export const COMPANY_PROFILES_UPDATED_EVENT = "company-profiles-updated";

/** @deprecated Use fetchCompanyProfiles() */
export const readCompanyProfiles = () => [];

/** @deprecated Use fetchCompanyProfiles() */
export const getCompanyProfileById = () => null;

/** @deprecated Use fetchCompanyProfiles() */
export const getCompanyProfileLabel = () => "";

/** @deprecated Use fetchCompanyProfiles() */
export const getCompanyProfileOptions = async () => {
  const profiles = await fetchCompanyProfiles();
  return profiles.map((profile) => ({
    value: String(profile.id),
    label: profile.companyName?.trim() || `Company ${profile.id}`,
  }));
};

/** @deprecated Profiles are persisted via API */
export const saveCompanyProfiles = () => {};

/** @deprecated Use createCompanyProfileApi */
export const createCompanyProfile = async (form) => createCompanyProfileApi(form);

/** @deprecated Use updateCompanyProfileApi */
export const updateCompanyProfile = async (companyId, form) =>
  updateCompanyProfileApi(companyId, form);
